// Shared brand-level primitives used across Godishni-Otcheti pages.
// Everything else comes from @podium/platform/ui (shadcn).

import type { ReactNode } from 'react'

/** Red, bold, uppercase-shouted word. For "САМО ЗА", "ВАЖНО!",
 *  "ЗАДЪЛЖИТЕЛНО", "НЕ СА", etc. */
export function AlertWord({ children }: { children: ReactNode }) {
  return <span className="font-bold text-destructive">{children}</span>
}

/** Cream strip announcing card payments, with the 5 payment-brand logos. */
export function PaymentsPromo() {
  const logos = [
    { slug: 'borica', alt: 'Borica' },
    { slug: 'visa', alt: 'VISA' },
    { slug: 'mastercard', alt: 'MasterCard' },
    { slug: 'maestro', alt: 'Maestro' },
    { slug: 'visa-electron', alt: 'VISA Electron' },
  ] as const
  return (
    <div
      className="flex flex-wrap items-center gap-4 rounded-md border p-3 text-sm"
      style={{ background: 'var(--bg-cream)' }}
    >
      <span>
        <b className="text-destructive">НОВО!</b> Вече можете да платите за публикациите и с дебитна
        или кредитна карта.
      </span>
      <div className="flex flex-wrap items-center gap-3">
        {logos.map(({ slug, alt }) => (
          <img key={slug} src={`/payments/${slug}.svg`} alt={alt} className="h-6 w-auto" />
        ))}
      </div>
    </div>
  )
}

/** Right-rail advert for the sibling brand e-Docs.bg. */
export function EDocsSidebar() {
  return (
    <aside>
      <a href="https://www.e-Docs.bg" target="_blank" rel="noreferrer" className="block">
        <img
          src="/edocs-advert.svg"
          alt="e-Docs.bg — електронни документи"
          className="block h-auto w-full"
        />
      </a>
    </aside>
  )
}
